module.exports = {
	"classes": [
		"auth-catalog-index-page",
		"header-dark"
	],
	"title": "Authenticate your users with any Identity Provider",
	"metas": {
		"description": "Easily add authentication to your app. Includes, identity management, single sign on, multifactor authentication, social login and more."
	},
	"opengraph": {
		"og:title": "Authenticate your users with any Identity Provider",
		"og:description": "Easily add authentication to your app. Includes, identity management, single sign on, multifactor authentication, social login and more.",
		"og:sitename": "Auth0"
	},
	"twittercard": {
		"twitter:title": "Authenticate your users with any Identity Provider",
		"twitter:description": "Easily add authentication to your app. Includes, identity management, single sign on, multifactor authentication, social login and more."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/auth-catalog-index/universal/metadata-technologies.json
// module id = 1102
// module chunks = 0